import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import {
  ViewType,
  DisallowNonIsolatedUserContexts,
  HideNonMarketplaceRetailerAgnosticStoreConfigs,
} from '@retailer-platform/dashboard/gin-and-tonic'
import { DomainRoute } from '../utils/domain/routingComponents'
import { foodstormAccessControl } from '../access-control/foodstormAccess.configuration'

const FoodstormCreateCartPage = lazy(() => import('../pages/create-cart/FoodstormCreateCartPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const foodstormRouter = (
  <DomainRoute route="foodstorm" accessControl={foodstormAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="foodstorm-create-cart"
        component={FoodstormCreateCartPage}
        scopePicker={{
          selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
          storeConfigOperationIntent: 'view',
          storeConfigFilter: siteOptions =>
            HideNonMarketplaceRetailerAgnosticStoreConfigs(
              DisallowNonIsolatedUserContexts(siteOptions)
            ),
        }}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
